<template>
  <div class="app-container">
    <!--  :before-save="onBeforeSave" -->
    <common-dialog ref="dialog" width="780px" title="手动点名" id-key="SectionId" form-label-width="90px"
      :save-func="api.save" :get-data-func="api.info" @opened="onOpened" @edit-opened="onEditOpened"
      @create-opened="onCreateOpened" @closed="reset" @close-saved="$emit('close-saved')">

      <template slot="form">

        <!--栋数 -->
        <div class="ridgepole-list">
          <div :class="{ 'ridgepole-item': true, 'activeRid': item.dongId == ridgepoleId }"
            v-for="(item, index) of ridgepoleTabs" :key="index" @click="selectRid(item.dongId)">{{ item.dongName }}
          </div>
        </div>
        <!--楼数-->
        <div class="tower-list">
          <div :class="{ 'tower-item': true, 'activeTower': item.id == towerId }" v-for="(item, index) of towerTabs"
            :key="index" @click="selectTower(item.id)">
            {{ item.towerNums + '楼' }}</div>
        </div>
        <!--宿舍号-->
        <div class="dorm-list">
          <div :class="{ 'dorm-item': true, 'activedorm': index == dormId }" v-for="(item, index) of dormList" :key="index"
            @click="detail(item,index)">
              <span >{{ item.towerNo }}</span>
              <span >{{ item.dormNo + '-' + item.dormNo }}</span>
          </div>
        </div>

      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <detail-dialog ref="detailDialog"></detail-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import detailDialog from "@/components/attendance/night/detailDialog.vue";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    detailDialog,
  },
  data() {
    return {
      activeId: null,
      //当前选中栋数
      ridgepoleId: null,
      //当前选中楼数
      towerId: null,
      dormId: null,
      //栋数
      ridgepoleTabs: [],
      //楼数
      towerTabs: [],
      //选中楼数据
      towerList: [],
      //选中数据
      dormList: [],
      data: [
        {
          dongId: 0,
          dongName: "A",
          towerList: [
            //楼层
            {
              id: 0,
              towerNums: 0,
              //宿舍
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  //学生
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 1,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 1,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 2,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 2,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 103,
                  dormNo: 108,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
                {
                  towerNo: 102,
                  dormNo: 107,

                },
              ]
            },
            {
              id: 1,
              towerNums: 1,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 2,
              towerNums: 2,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 3,
              towerNums: 3,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 4,
              towerNums: 4,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 5,
              towerNums: 5,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 6,
              towerNums: 6,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },

          ]
        },
        {
          dongId: 1,
          dongName: "B",
          towerList: [
            //楼层
            {
              id: 0,
              towerNums: 0,
              //宿舍
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  //学生
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 1,

                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 2,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 3,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 1,
              towerNums: 1,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 2,
              towerNums: 2,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 3,
              towerNums: 3,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 4,
              towerNums: 4,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 5,
              towerNums: 5,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 6,
              towerNums: 6,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },

          ]
        },
        {
          dongId: 2,
          dongName: "C",
          towerList: [
            //楼层
            {
              id: 0,
              towerNums: 0,
              //宿舍
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  //学生
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 1,

                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 2,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 3,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 1,
              towerNums: 1,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 2,
              towerNums: 2,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 3,
              towerNums: 3,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 4,
              towerNums: 4,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 5,
              towerNums: 5,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 6,
              towerNums: 6,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },

          ]
        },
        {
          dongId: 3,
          dongName: "D",
          towerList: [
            //楼层
            {
              id: 0,
              towerNums: 0,
              //宿舍
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  //学生
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 1,

                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 2,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 3,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 1,
              towerNums: 1,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 2,
              towerNums: 2,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 3,
              towerNums: 3,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 4,
              towerNums: 4,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 5,
              towerNums: 5,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },
            {
              id: 6,
              towerNums: 6,
              dormList: [
                {
                  towerNo: 101,
                  dormNo: 106,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
                {
                  towerNo: 102,
                  dormNo: 107,
                  studentList: [
                    {
                      studentsId: 1,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 2,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 3,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 4,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 5,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 6,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 17,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 8,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 9,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 10,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 11,
                      studentsName: '张三',
                      status: 0,
                    },
                    {
                      studentsId: 12,
                      studentsName: '张三',
                      status: 0,
                    },
                  ]
                },
              ]
            },

          ]
        },

      ],
      api: require("@/api/ed/section").default,
    };
  },
  methods: {
    onOpened() {
      // this.ridgepoleId = 0;
      // this.towerId = 0;
      this.getRidgepoleTabs()
    },
    onCreateOpened(data) { },
    onEditOpened(row) { },

    //选中栋
    selectRid(data) {
      this.ridgepoleId = data
      this.getTowerList();
    },
    //选中楼
    selectTower(data) {
      this.towerId = data
      this.getDataList();
    },

    //栋数
    getRidgepoleTabs() {

      this.data.reduce((acc, { dongId, dongName, ...item }) => {
        this.ridgepoleTabs.push({ dongId, dongName })
      }, [])
      this.towerList = this.data[0].towerList;

      if (this.ridgepoleId == null) {
        this.ridgepoleId = this.ridgepoleTabs[0].dongId
      }

      this.getTowerTabs();
    },
    //楼数
    getTowerTabs() {
      this.towerList.reduce((acc, { id, towerNums, ...item }) => {
        this.towerTabs.push({ id, towerNums })
      }, [])

      if (this.towerId == null) {
        this.towerId = this.towerTabs[0].id
      }
      this.getTowerList()

    },
    //
    getTowerList() {
      this.data.forEach(item => {
        if (item.dongId == this.ridgepoleId) {
          this.towerList = item.towerList
        }
      })
      this.getDataList();
    },
    //宿舍号
    getDataList() {
      this.towerList.forEach(item => {
        if (item.id == this.towerId) {
          this.dormList = item.dormList;
        }
      })
    },
    detail(data,id) {
      this.dormId = id
    
      this.$refs.detailDialog.open(data);
    },
    reset() {
      this.ridgepoleTabs = []
      //楼数
      this.towerTabs = []
      //选中楼数据
      this.towerList = []
      //选中数据
      this.dormList = [];

    },
  },
};
</script>
<style lang="scss" scoped>
.activedorm {
  color: #fff;
  background: #409EFF;
}

.activeRid {
  color: #fff;
  background: #409EFF;
}

.activeTower {
  color: #fff;
  background: #409EFF;
}

.ridgepole-list {
  display: flex;

  .ridgepole-item {
    padding: 5px 0;
    width: 60px;
    text-align: center;
    border: 1px solid #ddd;
    cursor: pointer;
  }
}

.tower-list {
  display: flex;

  .tower-item {
    padding: 5px 0;
    width: 60px;
    text-align: center;
    border: 1px solid #ddd;
    cursor: pointer;
  }
}

.dorm-list {
  display: flex;
  flex-wrap: wrap;

  .dorm-item {
    padding: 5px ;
    display: inline-flex;
    justify-content: space-between;
    width: 120px;
    text-align: center;
    border: 1px solid #ddd;
    cursor: pointer;
  }
}
</style>